import { createFileRoute, notFound } from "@tanstack/react-router";
export const Route = createFileRoute("/design-system/$slug")({
  beforeLoad: () => { throw notFound(); },
});